import { render } from "./UtenteDetail.vue?vue&type=template&id=103105ff"
import script from "./UtenteDetail.vue?vue&type=script&lang=js"
export * from "./UtenteDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__